import { QueryClient } from '@tanstack/react-query'
import { APP_SESSION } from '@zet/constants'

import { isApp } from '.'
import storageUtil from './storage'

let reloadAsync: (() => Promise<void>) | undefined

if (isApp) {
  // Lazy import to avoid including expo-updates in web bundle
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const updates = require('expo-updates')
  reloadAsync = updates.reloadAsync
}

interface enterMimicModeProps {
  data: {
    jwtToken: string
    refreshToken: string
  }
  queryClient: QueryClient
}

const getUserToken = () => {
  if (checkIsMimicMode()) {
    return storageUtil.getObject('mimicToken')
  } else {
    return storageUtil.getObject('token')
  }
}

const getUserRefreshToken = () => {
  if (storageUtil.getObject('mimicRefreshToken')) {
    return storageUtil.getObject('mimicRefreshToken')
  } else {
    return storageUtil.getObject('refreshToken')
  }
}

const checkIsMimicMode = () => Boolean(storageUtil.getObject('mimicToken'))

const enterMimicMode = async ({ data, queryClient }: enterMimicModeProps) => {
  if (data.jwtToken) {
    storageUtil.saveObject('mimicToken', data.jwtToken)
    queryClient.clear()
    queryClient.invalidateQueries()
    APP_SESSION.setReloadType('MIMIC_MODE')
    if (reloadAsync) await reloadAsync()
  }
  if (data.refreshToken) {
    storageUtil.saveObject('mimicRefreshToken', data.refreshToken)
  }
}

const exitMimicMode = async () => {
  if (checkIsMimicMode()) {
    storageUtil.deleteObject('mimicToken')
    storageUtil.deleteObject('mimicRefreshToken')
    APP_SESSION.setReloadType('MIMIC_MODE')
    if (reloadAsync) await reloadAsync()
  }
}

export {
  checkIsMimicMode,
  enterMimicMode,
  exitMimicMode,
  getUserRefreshToken,
  getUserToken,
}
